const taxDataMainOptions = {
  POSTAL_CODE: [
    {
      value: '06500',
      copyID: '06500',
    },
  ],

  NO_TAX_OBLIGATIONS: [
    {
      value: '616',
      copyID: 'Sin obligaciones fiscales',
    },
  ],

  NO_FLSCALES_EFFECTS: [
    {
      value: 'S01',
      copyID: 'Sin efectos fiscales',
    },
  ],

  RFC_NAME: [
    {
      value: 'XAXX010101000',
      copyID: 'XAXX010101000',
    },
  ],

  RFC_TYPE: [
    {
      value: '000',
      copyID: 'Selecciona un tipo de RFC',
      sendValue:'',
    },
    {
      value: 'R01',
      copyID: 'Persona Física',
      sendValue:'Física',
    },
    {
      value: 'R02',
      copyID: 'Persona Moral',
      sendValue:'Moral',
    },
    {
      value: 'R03',
      copyID: 'RFC Nacional',
      sendValue:'Nacional',
    },
    {
      value: 'R04',
      copyID: 'RFC Extranjero',
      sendValue:'Extranjero',
    },
  ],

  CFDI: [
    {
      value: '000',
      copyID: 'Selecciona un tipo de CFDI',
    },
    {
      value: 'G03',
      copyID: 'Gastos Generales',
    },
    {
      value: 'S01',
      copyID: 'Sin efectos fiscales',
    },
  ],

  TAX_REGIME_NATURAL_PERSON: [
    {
      value: '000',
      copyID: 'Selecciona un Régimen Fiscal',
    },
    {
      value: '605',
      copyID: 'Sueldos y Salarios e Ingresos Asimilados a Salarios',
      CFDiUses: [
        {
          value: '000',
          copyID: 'Selecciona un tipo de CFDI',
        },
        {
          value: 'S01',
          copyID: 'Sin efectos fiscales',
        },
      ],
    },
    {
      value: '606',
      copyID: 'Arrendamiento',
      CFDiUses: [
        {
          value: '000',
          copyID: 'Selecciona un tipo de CFDI',
        },
        {
          value: 'G03',
          copyID: 'Gastos en general',

        },
        {
          value: 'S01',
          copyID: 'Sin efectos fiscales',
        },
      ],
    },
    {
      value: '607',
      copyID: 'Régimen de Enajenación o Adquisición de Bienes',
      CFDiUses: [
        {
          value: '000',
          copyID: 'Selecciona un tipo de CFDI',
        },
        {
          value: 'S01',
          copyID: 'Sin efectos fiscales',
        },
      ],
    },
    {
      value: '608',
      copyID: 'Demás ingresos',
      CFDiUses: [
        {
          value: '000',
          copyID: 'Selecciona un tipo de CFDI',
        },
        {
          value: 'S01',
          copyID: 'Sin efectos fiscales',
        },
      ],
    },
    {
      value: '610',
      copyID:
        'Residentes en el Extranjero sin Establecimiento Permanente en México',
      CFDiUses: [
        {
          value: '000',
          copyID: 'Selecciona un tipo de CFDI',
        },
        {
          value: 'S01',
          copyID: 'Sin efectos fiscales',
        },
      ],
    },
    {
      value: '611',
      copyID: 'Ingresos por Dividendos (socios y accionistas)',
      CFDiUses: [
        {
          value: '000',
          copyID: 'Selecciona un tipo de CFDI',
        },
        {
          value: 'S01',
          copyID: 'Sin efectos fiscales',
        },
      ],
    },
    {
      value: '612',
      copyID: 'Personas Físicas con Actividades Empresariales y Profesionales',
      CFDiUses: [
        {
          value: '000',
          copyID: 'Selecciona un tipo de CFDI',
        },
        {
          value: 'G03',
          copyID: 'Gastos en general',

        },
        {
          value: 'S01',
          copyID: 'Sin efectos fiscales',
        },
      ],
    },
    {
      value: '614',
      copyID: 'Ingresos por intereses',
      CFDiUses: [
        {
          value: '000',
          copyID: 'Selecciona un tipo de CFDI',
        },
        {
          value: 'S01',
          copyID: 'Sin efectos fiscales',
        },
      ],
    },
    {
      value: '615',
      copyID: 'Régimen de los ingresos por obtención de premios',
      CFDiUses: [
        {
          value: '000',
          copyID: 'Selecciona un tipo de CFDI',
        },
        {
          value: 'S01',
          copyID: 'Sin efectos fiscales',
        },
      ],
    },
    {
      value: '616',
      copyID: 'Sin obligaciones fiscales',
      CFDiUses: [
        {
          value: '000',
          copyID: 'Selecciona un tipo de CFDI',
        },
        {
          value: 'S01',
          copyID: 'Sin efectos fiscales',
        },
      ],
    },
    {
      value: '621',
      copyID: 'Incorporación Fiscal',
      CFDiUses: [
        {
          value: '000',
          copyID: 'Selecciona un tipo de CFDI',
        },
        {
          value: 'G03',
          copyID: 'Gastos en general',

        },
        {
          value: 'S01',
          copyID: 'Sin efectos fiscales',
        },
      ],
    },
    {
      value: '625',
      copyID:
        'Régimen de las Actividades Empresariales con ingresos a través de Plataformas Tecnológicas',
      CFDiUses: [
        {
          value: '000',
          copyID: 'Selecciona un tipo de CFDI',
        },
        {
          value: 'G03',
          copyID: 'Gastos en general',

        },
        {
          value: 'S01',
          copyID: 'Sin efectos fiscales',
        },
      ],
    },
    {
      value: '626',
      copyID: 'Régimen Simplificado de Confianza',
      CFDiUses: [
        {
          value: '000',
          copyID: 'Selecciona un tipo de CFDI',
        },
        {
          value: 'G03',
          copyID: 'Gastos en general',

        },
        {
          value: 'S01',
          copyID: 'Sin efectos fiscales',
        },
      ],
    },
  ],

  TAX_REGIME_MORAL_PERSON: [
    {
      value: '000',
      copyID: 'Selecciona un Régimen Fiscal',
    },
    {
      value: '601',
      copyID: 'General de Ley Personas Morales',
      CFDiUses: [
        {
          value: '000',
          copyID: 'Selecciona un tipo de CFDI',
        },
        {
          value: 'G03',
          copyID: 'Gastos en general',

        },
        {
          value: 'S01',
          copyID: 'Sin efectos fiscales',
        },
      ],
    },
    {
      value: '603',
      copyID: 'Personas Morales con Fines no Lucrativos',
      CFDiUses: [
        {
          value: '000',
          copyID: 'Selecciona un tipo de CFDI',
        },
        {
          value: 'G03',
          copyID: 'Gastos en general',

        },
        {
          value: 'S01',
          copyID: 'Sin efectos fiscales',
        },
      ],
    },
    {
      value: '610',
      copyID:
        'Residentes en el Extranjero sin Establecimiento Permanente en México',
      CFDiUses: [
        {
          value: '000',
          copyID: 'Selecciona un tipo de CFDI',
        },
        {
          value: 'S01',
          copyID: 'Sin efectos fiscales',
        },
      ],
    },
    {
      value: '620',
      copyID:
        'Sociedades Cooperativas de Producción que optan por diferir sus ingresos',
      CFDiUses: [
        {
          value: '000',
          copyID: 'Selecciona un tipo de CFDI',
        },
        {
          value: 'G03',
          copyID: 'Gastos en general',
        },
        {
          value: 'S01',
          copyID: 'Sin efectos fiscales',
        },
      ],
    },
    {
      value: '622',
      copyID: 'Actividades Agrícolas, Ganaderas, Silvícolas y Pesqueras',
      CFDiUses: [
        {
          value: '000',
          copyID: 'Selecciona un tipo de CFDI',
        },
        {
          value: 'G03',
          copyID: 'Gastos en general',
        },
        {
          value: 'S01',
          copyID: 'Sin efectos fiscales',
        },
      ],
    },
    {
      value: '623',
      copyID: 'Opcional para Grupos de Sociedades',
      CFDiUses: [
        {
          value: '000',
          copyID: 'Selecciona un tipo de CFDI',
        },
        {
          value: 'G03',
          copyID: 'Gastos en general',
        },
        {
          value: 'S01',
          copyID: 'Sin efectos fiscales',
        },
      ],
    },
    {
      value: '624',
      copyID: 'Coordinados',
      CFDiUses: [
        {
          value: '000',
          copyID: 'Selecciona un tipo de CFDI',
        },
        {
          value: 'G03',
          copyID: 'Gastos en general',
        },
        {
          value: 'S01',
          copyID: 'Sin efectos fiscales',
        },
      ],
    },
    {
      value: '626',
      copyID: 'Régimen Simplificado de Confianza',
      CFDiUses: [
        {
          value: '000',
          copyID: 'Selecciona un tipo de CFDI',
        },
        {
          value: 'G03',
          copyID: 'Gastos en general',
        },
        {
          value: 'S01',
          copyID: 'Sin efectos fiscales',
        },
      ],
    },
  ],

  REGIMEN_DESCRIPTION: [
    {
      value: '000',
      copyID: 'Seleccionar',
    },
    {
      value: '605',
      copyID: 'Sueldos y Salarios e Ingresos Asimilados a Salarios',
    },
    {
      value: '606',
      copyID: 'Arrendamiento',
    },
    {
      value: '607',
      copyID: 'Régimen de Enajenación o Adquisición de Bienes',
    },
    {
      value: '608',
      copyID: 'Demás ingresos',
    },
    {
      value: '610',
      copyID:
        'Residentes en el Extranjero sin Establecimiento Permanente en México',
    },
    {
      value: '611',
      copyID: 'Ingresos por Dividendos (socios y accionistas)',
    },
    {
      value: '612',
      copyID: 'Personas Físicas con Actividades Empresariales y Profesionales',
    },
    {
      value: '614',
      copyID: 'Ingresos por intereses',
    },
    {
      value: '615',
      copyID: 'Régimen de los ingresos por obtención de premios',
    },
    {
      value: '616',
      copyID: 'Sin obligaciones fiscales',
    },
    {
      value: '621',
      copyID: 'Incorporación Fiscal',
    },
    {
      value: '625',
      copyID:
        'Régimen de las Actividades Empresariales con ingresos a través de Plataformas Tecnológicas',
    },
    {
      value: '601',
      copyID: 'General de Ley Personas Morales',
    },
    {
      value: '603',
      copyID: 'Personas Morales con Fines no Lucrativos',
    },
    {
      value: '620',
      copyID:
        'Sociedades Cooperativas de Producción que optan por diferir sus ingresos',
    },
    {
      value: '622',
      copyID: 'Actividades Agrícolas, Ganaderas, Silvícolas y Pesqueras',
    },
    {
      value: '623',
      copyID: 'Opcional para Grupos de Sociedades',
    },
    {
      value: '624',
      copyID: 'Coordinados',
    },
    {
      value: '626',
      copyID: 'Régimen Simplificado de Confianza',
    },
  ],

  PROCESSTYPE: [
    {
      value: '000',
      copyID: 'Seleccionar',
    },
    {
      value: 'Ordinario',
      copyID: 'Ordinario',
    },
    {
      value: 'Campaña',
      copyID: 'Campaña',
    },
    {
      value: 'Precampaña',
      copyID: 'Precampaña',
    },
  ],

  COMMITTEE_TYPE: [
    {
      value: '000',
      copyID: 'Seleccionar',
    },
    {
      value: 'Ejecutivo Nacional',
      copyID: 'Ejecutivo Nacional',
    },
    {
      value: 'Ejecutivo Estatal',
      copyID: 'Ejecutivo Estatal',
    },
  ],

  AMBIT: [
    {
      value: '000',
      copyID: 'Seleccionar',
    },
    {
      value: 'A01',
      copyID: 'Local',
    },
    {
      value: 'A02',
      copyID: 'Federal',
    },
  ],

  PAYMENT_TYPE: [
    {
      value: '000',
      copyID: 'Selecciona una opcion',
    },
    {
      value: '001',
      copyID: 'Efectivo',
    },
    {
      value: '002',
      copyID: 'Tarjeta de débito',
    },
    {
      value: '003',
      copyID: 'Tarjeta de crédito',
    },
  ],

  ENTITY: [
    {
      value: '000',
      copyID: 'Seleccionar',
    },
    {
      value: 'AGU',
      copyID: 'Aguascalientes',
    },
    {
      value: 'BCN',
      copyID: 'Baja California',
    },
    {
      value: 'BCS',
      copyID: 'Baja California Sur',
    },
    {
      value: 'CAM',
      copyID: 'Campeche',
    },
    {
      value: 'DIF',
      copyID: 'Ciudad de México',
    },
    {
      value: 'COA',
      copyID: 'Coahuila',
    },
    {
      value: 'COL',
      copyID: 'Colima',
    },
    {
      value: 'CHP',
      copyID: 'Chiapas',
    },
    {
      value: 'CHH',
      copyID: 'Chihuahua',
    },
    {
      value: 'DUR',
      copyID: 'Durango',
    },
    {
      value: 'GUA',
      copyID: 'Guanajuato',
    },
    {
      value: 'GRO',
      copyID: 'Guerrero',
    },
    {
      value: 'HID',
      copyID: 'Hidalgo',
    },
    {
      value: 'JAL',
      copyID: 'Jalisco',
    },
    {
      value: 'MEX',
      copyID: 'México',
    },
    {
      value: 'MIC',
      copyID: 'Michoacán',
    },
    {
      value: 'MOR',
      copyID: 'Morelos',
    },
    {
      value: 'NAY',
      copyID: 'Nayarit',
    },
    {
      value: 'NLE',
      copyID: 'Nuevo León',
    },
    {
      value: 'OAX',
      copyID: 'Oaxaca',
    },
    {
      value: 'PUE',
      copyID: 'Puebla',
    },
    {
      value: 'QTO',
      copyID: 'Queretato',
    },
    {
      value: 'ROO',
      copyID: 'Quintana Roo',
    },
    {
      value: 'SLP',
      copyID: 'San Luis Potosí',
    },
    {
      value: 'SIN',
      copyID: 'Sinaloa',
    },
    {
      value: 'SON',
      copyID: 'Sonora',
    },
    {
      value: 'TAB',
      copyID: 'Tabasco',
    },
    {
      value: 'TAM',
      copyID: 'Tamaulipas',
    },
    {
      value: 'TLA',
      copyID: 'Tlaxcala',
    },
    {
      value: 'VER',
      copyID: 'Veracruz',
    },
    {
      value: 'YUC',
      copyID: 'Yucatán',
    },
    {
      value: 'ZAC',
      copyID: 'Zacatecas',
    },
  ],

  ENTITY_OLD: [
    {
      value: '000',
      copyID: 'Seleccionar',
    },
    {
      value: 'E01',
      copyID: 'Aguascalientes',
    },
    {
      value: 'E02',
      copyID: 'Baja California',
    },
    {
      value: 'E03',
      copyID: 'Baja California Sur',
    },
    {
      value: 'E04',
      copyID: 'Campeche',
    },
    {
      value: 'E05',
      copyID: 'Ciudad de México',
    },
    {
      value: 'E06',
      copyID: 'Coahuila',
    },
    {
      value: 'E07',
      copyID: 'Colima',
    },
    {
      value: 'E08',
      copyID: 'Chiapas',
    },
    {
      value: 'E09',
      copyID: 'Chihuahua',
    },
    {
      value: 'E10',
      copyID: 'Durango',
    },
    {
      value: 'E11',
      copyID: 'Guanajuato',
    },
    {
      value: 'E12',
      copyID: 'Guerrero',
    },
    {
      value: 'E13',
      copyID: 'Hidalgo',
    },
    {
      value: 'E14',
      copyID: 'Jalisco',
    },
    {
      value: 'E15',
      copyID: 'México',
    },
    {
      value: 'E16',
      copyID: 'Michoacán',
    },
    {
      value: 'E17',
      copyID: 'Morelos',
    },
    {
      value: 'E18',
      copyID: 'Nayarit',
    },
    {
      value: 'E19',
      copyID: 'Nuevo León',
    },
    {
      value: 'E20',
      copyID: 'Oaxaca',
    },
    {
      value: 'E21',
      copyID: 'Puebla',
    },
    {
      value: 'E22',
      copyID: 'Querétaro',
    },
    {
      value: 'E23',
      copyID: 'Quintana Roo',
    },
    {
      value: 'E24',
      copyID: 'San Luis Potosí',
    },
    {
      value: 'E25',
      copyID: 'Sinaloa',
    },
    {
      value: 'E26',
      copyID: 'Sonora',
    },
    {
      value: 'E27',
      copyID: 'Tabasco',
    },
    {
      value: 'E28',
      copyID: 'Tamaulipas',
    },
    {
      value: 'E29',
      copyID: 'Tlaxcala',
    },
    {
      value: 'E30',
      copyID: 'Veracruz',
    },
    {
      value: 'E31',
      copyID: 'Yucatán',
    },
    {
      value: 'E32',
      copyID: 'Zacatecas',
    },
  ],
};

export const getNationalForeignData = ( typeOfRFC ) => {
  return {
    rfc: typeOfRFC === 'R04' ? 'XEXX010101000' : typeOfRFC === 'R03' ? 'XAXX010101000' : '',
    socialReason: typeOfRFC === 'R04' ? 'PUBLICO GENERAL' : typeOfRFC === 'R03' ? 'PUBLICO EN GENERAL' : '',
    postalCode:'06500',
    taxRegime:'616',
    cfdiUse:'S01',
    cfdiOptions:[{
      value: 'S01',
      copyID: 'Sin efectos fiscales',
    }],
    taxRegimeOptions: [{
      value: '616',
      copyID: 'Sin obligaciones fiscales',
    }],
  };
};

export default taxDataMainOptions;
